import { combineReducers } from 'redux';
import userInfo from './qmyxUserInfo';

export const createQmyxReducer = (asyncReducers = {}) => {
    return combineReducers({
        userInfo,
        ...asyncReducers
    });
};



// WEBPACK FOOTER //
// ./src/rootRedux/reducers/createQmyxReducer.js